import React, { Component } from 'react'
import { connect } from 'react-redux'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		vendor: doc(state, props.objectID)
	})
)

export class AddLineButton extends Component{
	render(){
		let { props } = this
		return(
			<div className="button">
				<span
					style={{
						cursor: "pointer"
					  , color: props.color || "#5ae4c3"
					}}
					onClick={()=>{
						let phones = props.vendor.phones || []
						props.LINE_ADD({
							_id: props.objectID
						  ,  phones: [...phones, {}]
						})
					 }}
				>
				   <svg
						width="18px"
						height="25px"
						viewBox="0 0 24 24"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
						style={{
							verticalAlign: "middle"
						  , marginRight: "4px"
						  , marginTop: "-2px"
						}}
					>
						<title>Group 2</title>
						<defs></defs>
							<g id="Page-1" stroke={props.color || "#5ae4c3"} strokeWidth="2" fill="none" fillRule="evenodd">
								<g id="Group-2" transform="translate(1.000000, 1.000000)" stroke={props.color || "#5ae4c3"} strokeWidth="2">
								<path d="M11,4.5 L11,17.5" id="Line" strokeLinecap="square"></path>
								<path d="M5,11 L17,11" id="Line" strokeLinecap="square"></path>
								<circle id="Oval-1" cx="11" cy="11" r="11"></circle>
							</g>
						</g>
					</svg>
					<span style={{borderBottom: "dotted 2px " +  (props.color || "#5ae4c3")}}>NEW</span>
				</span>
			</div>
		)
	}
}
export default connect(select, dataActions)(AddLineButton)



// WEBPACK FOOTER //
// ./src/routes/manager/vendorForm/AddPhoneButton.js